import React from 'react';
import { pdfService } from '../services/pdfService';

const PDFTest: React.FC = () => {
  // Sample data matching your actual invoice
  const sampleInvoiceData = {
    invoiceNumber: '25070-1',
    issueDate: '2025-08-08',
    dueDate: '2025-08-15',
    clientName: 'Mei Cui',
    companyName: 'One Studio Melbourne',
    clientAddress: 'Level 1, 495 Warrigal Road, Ashwood, VIC 3147',
    clientMobile: '0421131585',
    clientEmail: 'mei@onestudiomelbourne.com',
    projectNumber: '25070',
    projectLocation: '55 King Street\nTemplestowe',
    subtotal: 1000.00,
    gstAmount: 100.00,
    paidAmount: 0.00,
    totalDue: 1100.00,
    items: [
      {
        description: 'Structural Stage 1',
        rate: 500.00,
        quantity: 1,
        total: 500.00,
        exclGst: true
      },
      {
        description: 'Soil Report',
        rate: 500.00,
        quantity: 1,
        total: 500.00,
        exclGst: true
      }
    ]
  };

  const handleDownloadPDF = async () => {
    try {
      await pdfService.generateInvoicePDF(sampleInvoiceData);
    } catch (error) {
      alert('Error generating PDF: ' + error);
    }
  };

  const handlePreviewPDF = async () => {
    try {
      await pdfService.previewInvoicePDF(sampleInvoiceData);
    } catch (error) {
      alert('Error previewing PDF: ' + error);
    }
  };

  return (
    <div style={{
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      padding: '20px'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: '#1976d2',
        color: 'white',
        padding: '16px',
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h1 style={{
          margin: 0,
          fontSize: '20px',
          fontWeight: '500'
        }}>📄 PDF Generation Test</h1>
      </div>

      {/* Test Card */}
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        <h2 style={{ 
          color: '#333', 
          marginBottom: '20px',
          fontSize: '24px'
        }}>
          🧾 Linfinity Engineering Invoice
        </h2>

        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '20px', 
          borderRadius: '8px',
          marginBottom: '30px'
        }}>
          <h3 style={{ color: '#333', marginBottom: '15px' }}>Invoice Details:</h3>
          <div style={{ fontSize: '14px', lineHeight: '1.6' }}>
            <div><strong>Invoice Number:</strong> {sampleInvoiceData.invoiceNumber}</div>
            <div><strong>Client:</strong> {sampleInvoiceData.clientName}</div>
            <div><strong>Company:</strong> {sampleInvoiceData.companyName}</div>
            <div><strong>Project:</strong> {sampleInvoiceData.projectNumber} - {sampleInvoiceData.projectLocation.replace('\n', ', ')}</div>
            <div><strong>Total Due:</strong> ${sampleInvoiceData.totalDue.toFixed(2)}</div>
          </div>
        </div>

        <div style={{
          display: 'flex',
          gap: '15px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={handlePreviewPDF}
            style={{
              padding: '15px 30px',
              backgroundColor: '#ed8936',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#dd6b20'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#ed8936'}
          >
            👁️ Preview PDF
          </button>
          
          <button
            onClick={handleDownloadPDF}
            style={{
              padding: '15px 30px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1565c0'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#1976d2'}
          >
            📥 Download PDF
          </button>
        </div>

        <div style={{
          marginTop: '30px',
          padding: '15px',
          backgroundColor: '#e3f2fd',
          borderRadius: '8px',
          fontSize: '14px',
          color: '#0277bd'
        }}>
          <strong>🔍 What you'll see:</strong>
          <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
            <li>✅ Exact 7-column table layout matching HTML sample</li>
            <li>✅ Optimized single-page PDF with proper font sizing</li>
            <li>✅ Linfinity Engineering logo and branding</li>
            <li>✅ Real company details and bank information</li>
            <li>✅ Professional A4 format with alternating row colors</li>
            <li>✅ Proper Project | Address | Item | RATE | Qty | TOTAL | Excl. GST structure</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PDFTest;